import { render, staticRenderFns } from "./WechatPreAuthorize.vue?vue&type=template&id=203ddc83"
import script from "./WechatPreAuthorize.vue?vue&type=script&lang=js"
export * from "./WechatPreAuthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports